import { PosMerchantAPI } from 'services/api/pos/merchants';

export const getPosMerchant = (request: { id: string }) => {
  return PosMerchantAPI.getPosMerchant(request.id);
};
